import { get, isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { GET_PACKAGE, GET_SUB_SCRIPTION, PAYMENT_HISTORY, GET_MY_RECORDS_USAGE } from '../../redux/actions/type'
import { Views } from '../../views'

const UserProfile = ({ keycloak }) => {
    const { UserProfile } = Views
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isEmpty(keycloak) && !keycloak.authenticated) {
            window.location.href = '/portal'
        }
    }, [keycloak])

    useEffect(() => {
        if (!isEmpty(keycloak) && keycloak.authenticated) {
            dispatch({
                type: GET_SUB_SCRIPTION
            })
            dispatch({
                type: GET_PACKAGE
            })
            dispatch({
                type: PAYMENT_HISTORY
            })
            dispatch({
                type: GET_MY_RECORDS_USAGE
            })
        }
    }, [dispatch, keycloak])

    return (
        !isEmpty(keycloak) && keycloak.authenticated ? (
            <UserProfile keycloak={keycloak} />
        ) : null
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, "keycloak", "")
})

export default connect(mapStateToProps, {})(UserProfile)
